export const RU_TRANSLATE = {
    "HELLO": "Привет",
    "back": "Назад",
    "ok": "Ок",
    "cancel": "Отмена",
    "startBtn": "Начать",

    "detox": "Детокс",
    "detoxPlan": "Меню и Рецепты",
    "settings": "Настройки",
    "shoppingList": "Список покупок",
    "termsOfUse": "Условия использования",
    "guides": "Руководства",
    "aboutUs": "О нас",
    "slogan": "21 день здорового очищения организма",

    "dailyMenu": "Ежедневное меню",
    "day": "День",
    "finish": "Что дальше",
    "ingredients": "Ингредиенты",
    "instructions": "Инструкции",
    "intro": "Введение",
    "markThisDay": "Отметить этот день как выполненный",
    "serving": "Порция",
    "servings": "Порции",
    "meals": [
        {
            "name": "Завтрак"
        },
        {
            "name": "Второй завтрак"
        },
        {
            "name": "Обед"
        },
        {
            "name": "Полдник"
        },
        {
            "name": "Ужин"
        }
    ],

    "more": "ещё",
    "language": "Язык",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "Единица",
    "selectDetoxPlan": "Выберите свой план детокса",
    "detoxPlans": "Планы детокса",
    "restart": "Перезапустить",
    "start": "Начать",
    "days": "дней",
    "standard": "стандарт",
    "vegan": "веган",
    "vegetarian": "вегетарианец",
    "pescetarian": "пескетарианец",
    "wellDone": "Молодец!",
    "whatsNow": "Что теперь",

    "youDidIt": "Молодец, ты это сделал",
    "weProud": "Мы гордимся тобой,",
    "presentYourself": "Ты сделал себе удивительный подарок",

    "messages": {
        "resetApp": {
            "title": "Сбросить приложение",
            "content": "Это действие сбросит список покупок и дни, отмеченные как выполненные.\nНажмите ОК, если хотите сбросить приложение."
        }
    },
}
